<template>
  <div class="login-container">
    <div class="login-box">
      <div class="login-header">
        <img src="@/assets/image/logo.png" alt="Logo" class="logo">
        <h2>常宜律师事务所</h2>
      </div>
      
      <div class="login-type">
        <span 
          :class="{ active: loginType === 'account' }"
          @click="loginType = 'account'">
          账号密码登录
        </span>
        <span 
          :class="{ active: loginType === 'phone' }"
          @click="loginType = 'phone'">
          手机号登录
        </span>
      </div>
      
      <el-form 
        v-if="loginType === 'account'"
        :model="accountForm" 
        :rules="accountRules" 
        ref="accountForm" 
        class="login-form">
        <el-form-item prop="username">
          <el-input 
            v-model="accountForm.username"
            prefix-icon="el-icon-user"
            placeholder="请输入用户名">
          </el-input>
        </el-form-item>
        
        <el-form-item prop="password">
          <el-input 
            v-model="accountForm.password"
            prefix-icon="el-icon-lock"
            type="password"
            placeholder="请输入密码"
            @keyup.enter.native="handleAccountLogin">
          </el-input>
        </el-form-item>
        
        <el-form-item>
          <el-checkbox v-model="accountForm.remember">记住密码</el-checkbox>
          <el-button type="text" class="forget-pwd">忘记密码？</el-button>
        </el-form-item>
        
        <el-form-item>
          <el-button 
            type="primary" 
            class="login-button"
            :loading="loading"
            @click="handleAccountLogin">
            登录
          </el-button>
        </el-form-item>
      </el-form>
      
      <el-form 
        v-else
        :model="phoneForm" 
        :rules="phoneRules" 
        ref="phoneForm" 
        class="login-form">
        <el-form-item prop="phone">
          <el-input 
            v-model="phoneForm.phone"
            prefix-icon="el-icon-mobile-phone"
            placeholder="请输入手机号">
          </el-input>
        </el-form-item>
        
        <el-form-item prop="code">
          <div class="code-input">
            <el-input 
              v-model="phoneForm.code"
              prefix-icon="el-icon-message"
              placeholder="请输入验证码">
            </el-input>
            <el-button 
              type="primary" 
              :disabled="!!timer || !phoneForm.phone"
              @click="sendCode">
              {{ codeText }}
            </el-button>
          </div>
        </el-form-item>
        
        <el-form-item>
          <el-button 
            type="primary" 
            class="login-button"
            :loading="loading"
            @click="handlePhoneLogin">
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import caseApi from '@/api/case'

export default {
  name: 'Login',
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'))
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    
    return {
      loginType: 'account',
      accountForm: {
        username: '',
        password: '',
        remember: false
      },
      phoneForm: {
        phone: '',
        code: ''
      },
      accountRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
        ]
      },
      phoneRules: {
        phone: [
          { required: true, trigger: 'blur', validator: validatePhone }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { len: 6, message: '验证码长度为6位', trigger: 'blur' }
        ]
      },
      loading: false,
      timer: null,
      countdown: 60,
      codeText: '获取验证码'
    }
  },
  created() {
    const savedUsername = localStorage.getItem('username')
    if (savedUsername) {
      this.accountForm.username = savedUsername
      this.accountForm.remember = true
    }
  },
  methods: {
    async handleAccountLogin() {
      try {
        await this.$refs.accountForm.validate()
        
        let data = {
          account: this.accountForm.username,
          password: this.accountForm.password
        }
        this.loading = true
        const response = await caseApi.login(data)
        console.log(response);
        if (response.status === 200) {
          if(response.data.user.lawyer != 1 && response.data.user.isadmin  != 1) {
            this.$message.error('您不是律师，无法登录')
            return;
           }
          this.handleLoginSuccess(response)
        } else {
          this.$message.error(response.message || '登录失败')
        }
      } catch (error) {
        this.$message.error('登录失败，请重试')
        console.error('登录失败:', error)
      } finally {
        this.loading = false
      }
    },
    
    async handlePhoneLogin() {
      try {
        await this.$refs.phoneForm.validate()
        
        let data = {
          phone: this.phoneForm.phone,
          captcha: this.phoneForm.code,
          spread:0
        }
        this.loading = true
        const response = await caseApi.loginByPhone(data)
        
        console.log(response);
        if (response.status === 200) {
          if(response.data.user.lawyer != 1 && response.data.user.isadmin  != 1) {
            this.$message.error('您不是律师，无法登录')
            return;
           }
          this.handleLoginSuccess(response)
        } else {
          this.$message.error(response.message || '登录失败')
        }
      } catch (error) {
        this.$message.error('登录失败，请重试')
        console.error('登录失败:', error)
      } finally {
        this.loading = false
      }
    },
    
    handleLoginSuccess(response) {
      localStorage.setItem('token', response.data.token)
      
      if (this.loginType === 'account' && this.accountForm.remember) {
        localStorage.setItem('username', this.accountForm.username)
      } else {
        localStorage.removeItem('username')
      }
      
      this.$store.commit('setUserInfo', response.data.user)
      
      this.$message.success('登录成功')
      this.$router.push('/')
    },
    
    async sendCode() {
      try {
        await this.$refs.phoneForm.validateField('phone')
        
        const response = await caseApi.sendSmsCode({
          phone: this.phoneForm.phone,
          type: 'login'
        })
        
        if (response.status === 200) {
          this.$message.success('验证码已发送')
          this.startCountdown()
        } else {
          this.$message.error(response.message || '发送失败')
        }
      } catch (error) {
        console.error('发送验证码失败:', error)
      }
    },
    
    startCountdown() {
      this.countdown = 60
      this.codeText = `${this.countdown}s后重新获取`
      
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--
          this.codeText = `${this.countdown}s后重新获取`
        } else {
          clearInterval(this.timer)
          this.timer = null
          this.codeText = '获取验证码'
        }
      }, 1000)
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }
}
</script>

<style lang="less" scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f2f5;
//   background-image: url('@/assets/image/login-bg.png');
  background-size: cover;
  background-position: center;
  
  .login-box {
    width: 400px;
    padding: 40px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(0,0,0,0.1);
    
    .login-header {
      text-align: center;
      margin-bottom: 40px;
      
      .logo {
        height: 48px;
        margin-bottom: 16px;
      }
      
      h2 {
        margin: 0;
        font-size: 24px;
        color: #262626;
        font-weight: 500;
      }
    }
    
    .login-type {
      display: flex;
      justify-content: center;
      margin-bottom: 24px;
      
      span {
        padding: 8px 24px;
        cursor: pointer;
        color: #8c8c8c;
        transition: all 0.3s;
        position: relative;
        
        &:hover {
          color: #1890ff;
        }
        
        &.active {
          color: #1890ff;
          font-weight: 500;
          
          &::after {
            content: '';
            position: absolute;
            bottom: -2px;
            left: 50%;
            transform: translateX(-50%);
            width: 24px;
            height: 2px;
            background: #1890ff;
            border-radius: 1px;
          }
        }
        
        & + span {
          margin-left: 24px;
        }
      }
    }
    
    .login-form {
      .el-input {
        height: 40px;
        
        :deep(.el-input__inner) {
          height: 40px;
          line-height: 40px;
        }
      }
      
      .forget-pwd {
        float: right;
      }
      
      .login-button {
        width: 100%;
        height: 40px;
      }
      
      .code-input {
        display: flex;
        gap: 12px;
        
        .el-input {
          flex: 1;
        }
        
        .el-button {
          width: 120px;
          padding: 0;
          
          &:disabled {
            color: #bfbfbf;
            background: #f5f5f5;
            border-color: #d9d9d9;
          }
        }
      }
    }
  }
}
</style> 